/**
 * Resolve primary key from API / SQL rows regardless of common casing variants.
 */

export function getRecordId(record) {
  if (record == null || typeof record !== 'object') return undefined;
  const v = record.id ?? record.Id ?? record.ID;
  if (v === undefined || v === null || v === '') return undefined;
  return v;
}

/** Numeric id for API calls (recordId query/body). */
export function getNumericRecordId(record) {
  const v = getRecordId(record);
  if (v === undefined) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}
